import React from "react";

export const NoomSupportLink = (
  <a href="https://www.noom.com/support/" target="_blank" rel="noreferrer">
    https://www.noom.com/support/
  </a>
);
